export const environment = {
  url: 'https://chevronipcms.com/api',
  socket: 'https://chevronipcms.com',
  prod: false,
};
